import { render, staticRenderFns } from "./WasteIndex.vue?vue&type=template&id=491f83ac&"
import script from "./WasteIndex.vue?vue&type=script&lang=js&"
export * from "./WasteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports